/**
 * v35. 녹화물 탐색의 목표 초 (`docs/71` §2.1 · 절대 규칙 91).
 *
 * **판정은 이 함수 하나다.** 코어의 `seekBy()` 가 부르고, 어댑터는 그 결과로 갈 뿐 컷을 모른다.
 */
/** 버튼 한 번의 탐색 폭(초) — 「10초 전」·「10초 후」 */
export const SEEK_STEP_SEC = 10;
/**
 * 컷 앞 여유(초). **탐색은 다음 컷의 이만큼 앞에서 선다.**
 *
 * 덮는 것이 둘이다 — ① 아직 요청 전인 미드롤은 탐색 뒤 첫 `timeupdate` 에서 광고를 묻는데
 * 그 왕복(데모에서 1초 안) ② 어댑터가 정책상 컷을 청크 경계로 **올린다**(≤2초 · 규칙 52).
 * 여유가 그보다 짧으면 지난 컷을 무장하게 되고, 어댑터가 곧바로 잘라 **컷 자리로 되돌아간다**
 * — 「10초 후」를 눌렀는데 뒤로 간다.
 */
export const SEEK_CUT_GUARD_SEC = 5;
/**
 * 탐색할 초. **지금과 같은 값을 돌려주면 움직이지 않는다는 뜻이다.**
 *
 * ★ **앞으로 가라는데 뒤로 가는 값을 내지 않는다.** 상한이 지금보다 앞이면(이미 컷 앞
 * 여유 안에 있다) 제자리다.
 */
export function seekTarget(input) {
    const { elapsedSec, deltaSec } = input;
    if (!Number.isFinite(deltaSec) || deltaSec === 0)
        return elapsedSec;
    if (deltaSec < 0)
        return Math.max(0, elapsedSec + deltaSec);
    if (input.forwardLocked || !(input.durationSec > 0))
        return elapsedSec;
    const end = input.nextCutSec === null ? input.durationSec : Math.min(input.durationSec, input.nextCutSec);
    const target = Math.min(elapsedSec + deltaSec, end - SEEK_CUT_GUARD_SEC);
    return target > elapsedSec ? target : elapsedSec;
}
//# sourceMappingURL=seek-policy.js.map